import { takeLatest, call, put } from "redux-saga/effects";

import AuthService from "../../../services/Auth/AuthService";
import * as types from "../actionTypes";

export function* userLogoutWatcherSaga() {
  yield takeLatest(types.AUTH_API_LOGOUT_REQUEST, workerSaga);
}

export function* workerSaga({ isLoggedIn, res, rej }) {
  try {
    yield call(AuthService.logout);
    isLoggedIn.current = false;
    res();
  } catch (error) {
    rej(error);
  }
}
